import Countdown from "react-countdown";

const Completionist = () => <span></span>;

// Renderer callback with condition
const renderer = ({ hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a completed state
    return <Completionist />;
  } else {
    // Render a countdown
    return (
      <div className="mint-countdown">
        <h3>Auction starting in</h3>
        <div className="mint-time">
          <div>
            {hours}
            <span>Hours</span>
          </div>
          <div>
            {minutes}
            <span>Minutes</span>
          </div>
          <div>
            {seconds}
            <span>Seconds</span>
          </div>
        </div>
      </div>
    );
  }
};

const MintCountdown = function (props) {
  return <Countdown date="2021-09-07T23:00:00" renderer={renderer} />;
};

export default MintCountdown;
